// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.monitoring-page {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}

.monitoring-page h1 {
  margin: 0 0 8px 0;
  font-size: 24px;
}

.monitoring-page .subtitle {
  color: #666;
  margin-bottom: 20px;
  font-size: 14px;
}

.live-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  margin-left: 10px;
  vertical-align: middle;
}

.live-badge .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.live-badge.open {
  background: #e7f7ed;
  color: #1f7a3a;
}
.live-badge.open .dot {
  background: #2ea84a;
  box-shadow: 0 0 4px #2ea84a;
}

.live-badge.connecting,
.live-badge.idle {
  background: #fff5e0;
  color: #8a6d1c;
}
.live-badge.connecting .dot,
.live-badge.idle .dot {
  background: #d4a72c;
}

.live-badge.closed,
.live-badge.error {
  background: #f7e1e1;
  color: #8a2c2c;
}
.live-badge.closed .dot,
.live-badge.error .dot {
  background: #c14545;
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.kpi-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
}

.kpi-card .label {
  color: #666;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
}

.kpi-card .value {
  font-size: 28px;
  font-weight: 600;
  color: #111;
}

.kpi-card.alert .value {
  color: #c14545;
}

.kpi-card.warning .value {
  color: #d4a72c;
}

.section {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.section h2 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
}

.channel-bar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.channel-pill {
  background: #f0f3f7;
  border-radius: 14px;
  padding: 6px 12px;
  font-size: 13px;
}
.channel-pill .count {
  font-weight: 600;
  margin-left: 6px;
}

.sentiment-bar {
  display: flex;
  height: 24px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}
.sentiment-bar > div {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #fff;
  font-weight: 500;
}
.sentiment-bar .pos { background: #2ea84a; }
.sentiment-bar .neu { background: #9ca3af; }
.sentiment-bar .neg { background: #c14545; }
.sentiment-bar .mix { background: #d4a72c; }

.problematic-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.problematic-list li {
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.problematic-list li:last-child { border-bottom: none; }
.problematic-list li:hover { background: #fafafa; }

.problematic-list .meta {
  font-size: 12px;
  color: #666;
}

.filters-bar {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 12px;
  align-items: center;
}
.filters-bar select,
.filters-bar input {
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
}

.filters-bar label {
  font-size: 12px;
  color: #444;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.conversations-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.conversations-table th {
  text-align: left;
  padding: 10px 8px;
  background: #f7f8fa;
  border-bottom: 1px solid #e5e7eb;
  font-weight: 600;
  color: #444;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.conversations-table td {
  padding: 10px 8px;
  border-bottom: 1px solid #f0f0f0;
}
.conversations-table tr {
  cursor: pointer;
}
.conversations-table tr:hover {
  background: #fafafa;
}
.conversations-table tr.problematic {
  background: #fef6f6;
}
.conversations-table tr.problematic:hover {
  background: #fdeded;
}
.conversations-table tr.live-fresh {
  background: #fffae0;
  transition: background 1.5s ease-out;
}

.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
}
.badge.pos { background: #e7f7ed; color: #1f7a3a; }
.badge.neu { background: #f0f3f7; color: #444; }
.badge.neg { background: #f7e1e1; color: #8a2c2c; }
.badge.mix { background: #fff5e0; color: #8a6d1c; }
.badge.problematic { background: #c14545; color: #fff; }
.badge.escalated { background: #fde9c5; color: #8a4f00; }
.badge.sla { background: #c14545; color: #fff; }
.badge.channel { background: #eef2f7; color: #2c3e50; }

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}
.pagination button {
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 6px;
  cursor: pointer;
}
.pagination button:disabled { opacity: 0.5; cursor: not-allowed; }

.thread {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}
.thread .msg {
  padding: 10px 12px;
  border-radius: 10px;
  max-width: 75%;
  position: relative;
}
.thread .msg.inbound {
  background: #f0f3f7;
  align-self: flex-start;
  border-bottom-left-radius: 2px;
}
.thread .msg.outbound {
  background: #dbeafe;
  align-self: flex-end;
  border-bottom-right-radius: 2px;
}
.thread .msg .meta {
  font-size: 11px;
  color: #666;
  margin-top: 4px;
}

.escalation-timeline {
  margin-top: 16px;
  padding-left: 16px;
  border-left: 2px solid #e5e7eb;
}
.escalation-timeline .item {
  margin-bottom: 12px;
  font-size: 13px;
}
.escalation-timeline .item .when {
  font-size: 11px;
  color: #666;
}

.problematic-reasons {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 6px;
}
.problematic-reasons .badge {
  background: #fff;
  border: 1px solid #c14545;
  color: #c14545;
}

.error-banner {
  background: #f7e1e1;
  color: #8a2c2c;
  padding: 10px 14px;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 13px;
}

.empty-state {
  text-align: center;
  color: #888;
  padding: 32px;
  font-size: 14px;
}

.toolbar-right {
  margin-left: auto;
  display: flex;
  gap: 10px;
  align-items: center;
}

.monitoring-page .btn {
  padding: 6px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 13px;
}
.monitoring-page .btn:hover { background: #f7f8fa; }
.monitoring-page .btn.primary { background: #2563eb; color: #fff; border-color: #2563eb; }
.monitoring-page .btn.primary:hover { background: #1d4ed8; }
`, "",{"version":3,"sources":["webpack://./src/admin/pages/MonitoringDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;AAC3C,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA,kCAAkC,mBAAmB,EAAE;AACvD,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,aAAa,mBAAmB,EAAE,WAAW,EAAE;AAC/C,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,aAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,qBAAqB,mBAAmB,EAAE,WAAW,EAAE;AACvD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,aAAa,mBAAmB,EAAE,WAAW,EAAE;AAC/C,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;;AAEtD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA,8BAA8B,mBAAmB,EAAE;AACnD,gCAAgC,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AACzF,sCAAsC,mBAAmB,EAAE","sourcesContent":[".monitoring-page {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.monitoring-page h1 {\n  margin: 0 0 8px 0;\n  font-size: 24px;\n}\n\n.monitoring-page .subtitle {\n  color: #666;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.live-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  margin-left: 10px;\n  vertical-align: middle;\n}\n\n.live-badge .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.live-badge.open {\n  background: #e7f7ed;\n  color: #1f7a3a;\n}\n.live-badge.open .dot {\n  background: #2ea84a;\n  box-shadow: 0 0 4px #2ea84a;\n}\n\n.live-badge.connecting,\n.live-badge.idle {\n  background: #fff5e0;\n  color: #8a6d1c;\n}\n.live-badge.connecting .dot,\n.live-badge.idle .dot {\n  background: #d4a72c;\n}\n\n.live-badge.closed,\n.live-badge.error {\n  background: #f7e1e1;\n  color: #8a2c2c;\n}\n.live-badge.closed .dot,\n.live-badge.error .dot {\n  background: #c14545;\n}\n\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.kpi-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.kpi-card .label {\n  color: #666;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  margin-bottom: 8px;\n}\n\n.kpi-card .value {\n  font-size: 28px;\n  font-weight: 600;\n  color: #111;\n}\n\n.kpi-card.alert .value {\n  color: #c14545;\n}\n\n.kpi-card.warning .value {\n  color: #d4a72c;\n}\n\n.section {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n}\n\n.section h2 {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.channel-bar {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.channel-pill {\n  background: #f0f3f7;\n  border-radius: 14px;\n  padding: 6px 12px;\n  font-size: 13px;\n}\n.channel-pill .count {\n  font-weight: 600;\n  margin-left: 6px;\n}\n\n.sentiment-bar {\n  display: flex;\n  height: 24px;\n  border-radius: 4px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n}\n.sentiment-bar > div {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  color: #fff;\n  font-weight: 500;\n}\n.sentiment-bar .pos { background: #2ea84a; }\n.sentiment-bar .neu { background: #9ca3af; }\n.sentiment-bar .neg { background: #c14545; }\n.sentiment-bar .mix { background: #d4a72c; }\n\n.problematic-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.problematic-list li {\n  padding: 10px 0;\n  border-bottom: 1px solid #f0f0f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n.problematic-list li:last-child { border-bottom: none; }\n.problematic-list li:hover { background: #fafafa; }\n\n.problematic-list .meta {\n  font-size: 12px;\n  color: #666;\n}\n\n.filters-bar {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n  align-items: center;\n}\n.filters-bar select,\n.filters-bar input {\n  padding: 6px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.filters-bar label {\n  font-size: 12px;\n  color: #444;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.conversations-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.conversations-table th {\n  text-align: left;\n  padding: 10px 8px;\n  background: #f7f8fa;\n  border-bottom: 1px solid #e5e7eb;\n  font-weight: 600;\n  color: #444;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n.conversations-table td {\n  padding: 10px 8px;\n  border-bottom: 1px solid #f0f0f0;\n}\n.conversations-table tr {\n  cursor: pointer;\n}\n.conversations-table tr:hover {\n  background: #fafafa;\n}\n.conversations-table tr.problematic {\n  background: #fef6f6;\n}\n.conversations-table tr.problematic:hover {\n  background: #fdeded;\n}\n.conversations-table tr.live-fresh {\n  background: #fffae0;\n  transition: background 1.5s ease-out;\n}\n\n.badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 10px;\n  font-size: 11px;\n  font-weight: 500;\n}\n.badge.pos { background: #e7f7ed; color: #1f7a3a; }\n.badge.neu { background: #f0f3f7; color: #444; }\n.badge.neg { background: #f7e1e1; color: #8a2c2c; }\n.badge.mix { background: #fff5e0; color: #8a6d1c; }\n.badge.problematic { background: #c14545; color: #fff; }\n.badge.escalated { background: #fde9c5; color: #8a4f00; }\n.badge.sla { background: #c14545; color: #fff; }\n.badge.channel { background: #eef2f7; color: #2c3e50; }\n\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 12px;\n}\n.pagination button {\n  padding: 6px 12px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.pagination button:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.thread {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 12px;\n}\n.thread .msg {\n  padding: 10px 12px;\n  border-radius: 10px;\n  max-width: 75%;\n  position: relative;\n}\n.thread .msg.inbound {\n  background: #f0f3f7;\n  align-self: flex-start;\n  border-bottom-left-radius: 2px;\n}\n.thread .msg.outbound {\n  background: #dbeafe;\n  align-self: flex-end;\n  border-bottom-right-radius: 2px;\n}\n.thread .msg .meta {\n  font-size: 11px;\n  color: #666;\n  margin-top: 4px;\n}\n\n.escalation-timeline {\n  margin-top: 16px;\n  padding-left: 16px;\n  border-left: 2px solid #e5e7eb;\n}\n.escalation-timeline .item {\n  margin-bottom: 12px;\n  font-size: 13px;\n}\n.escalation-timeline .item .when {\n  font-size: 11px;\n  color: #666;\n}\n\n.problematic-reasons {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 6px;\n}\n.problematic-reasons .badge {\n  background: #fff;\n  border: 1px solid #c14545;\n  color: #c14545;\n}\n\n.error-banner {\n  background: #f7e1e1;\n  color: #8a2c2c;\n  padding: 10px 14px;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  font-size: 13px;\n}\n\n.empty-state {\n  text-align: center;\n  color: #888;\n  padding: 32px;\n  font-size: 14px;\n}\n\n.toolbar-right {\n  margin-left: auto;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.monitoring-page .btn {\n  padding: 6px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 13px;\n}\n.monitoring-page .btn:hover { background: #f7f8fa; }\n.monitoring-page .btn.primary { background: #2563eb; color: #fff; border-color: #2563eb; }\n.monitoring-page .btn.primary:hover { background: #1d4ed8; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
